import React from 'react';

function ClubTeamsView({ clubTeams, openNewTeamProfile, openTeamProfile, profileContent, setTeamProfile, setTeamSearch, setView, teamProfile, teamSearch, teams }) {
  return (
    <div className="page-container-lg">
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0' }}>
        <button className="w3-button w3-theme-l4 w3-round" title="Back to dashboard" aria-label="Back to dashboard" onClick={() => { setView('dashboard'); setTeamProfile(null); }}>
          <i className="fa fa-arrow-left"></i>
        </button>
        <h2 style={{ margin: 0, flex: 1 }}><i className="fa fa-shield w3-text-theme w3-margin-right"></i>Club Teams ({clubTeams.length})</h2>
        <button className="w3-button w3-round w3-theme-l2" onClick={openNewTeamProfile}>
          <i className="fa fa-plus w3-margin-right"></i><span className="w3-hide-small">Add Team</span>
        </button>
      </div>
      <div className="split-pane">
        {/* LEFT — Team list */}
        <div className="split-list">
          <div className="w3-card w3-round w3-white">
            <div className="w3-container w3-padding">
              <div style={{ position: 'relative', marginBottom: '10px' }}>
                <i className="fa fa-search" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#999' }}></i>
                <input className="w3-input w3-border w3-round" placeholder="Search teams…"
                  style={{ paddingLeft: '32px' }}
                  value={teamSearch} onChange={e => setTeamSearch(e.target.value)} />
              </div>
              {clubTeams.length === 0 ? (
                <p className="w3-text-grey w3-center" style={{ padding: '16px 0' }}>
                  <i className="fa fa-shield w3-xxlarge w3-text-light-grey" style={{ display: 'block', marginBottom: '8px' }}></i>
                  <em>No teams yet. Click "Add Team" to get started.</em>
                </p>
              ) : (
                <div className="split-list-scroll">
                  {clubTeams.filter(t => {
                    if (!teamSearch.trim()) return true;
                    return t.name.toLowerCase().includes(teamSearch.toLowerCase());
                  }).map(t => (
                    <div key={t.id}
                      className={`player-row w3-hover-light-grey ${teamProfile && teamProfile.id === t.id ? 'split-active' : ''}`}
                      onClick={() => openTeamProfile(t.id)} style={{ cursor: 'pointer' }}>
                      <div className="player-avatar" style={{ background: '#607d8b' }}><i className="fa fa-shield"></i></div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 600, fontSize: 'var(--gs-text-sm)' }}>{t.name}
                          {t.discipline && <span className="w3-tag w3-round w3-small w3-theme-l3" style={{ marginLeft: '8px', fontSize: 'var(--gs-text-xs)', padding: '1px 8px', textTransform: 'capitalize' }}>{t.discipline}</span>}
                        </div>
                      </div>
                      <i className="fa fa-chevron-right w3-text-light-grey"></i>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* RIGHT — Team profile detail */}
        <div className="split-detail">
          {teamProfile ? profileContent : (
            <div className="w3-card w3-round w3-white" style={{ padding: '48px 24px', textAlign: 'center' }}>
              <i className="fa fa-shield" style={{ fontSize: '3em', color: '#ccc' }}></i>
              <p className="w3-text-grey" style={{ marginTop: '12px' }}><em>Select a team to view their profile</em></p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ClubTeamsView;
